import { render } from "./CreateCoupons.vue?vue&type=template&id=8275e9f0&scoped=true"
import script from "./CreateCoupons.vue?vue&type=script&lang=js"
export * from "./CreateCoupons.vue?vue&type=script&lang=js"

import "./CreateCoupons.vue?vue&type=style&index=0&id=8275e9f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8275e9f0"]])

export default __exports__